import React, { Component } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import Container from 'partials/Container';
import css from 'css';
import api from 'api';
import { Select } from 'partials/formElements';
import { sortByPath } from 'helpers'

/*
|--------------------------------------------------------------------------
|  Time plan component
|--------------------------------------------------------------------------
| props:
| - theme [string] 'calendar', 'pills', 'list'
*/
class Timeplan extends Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            theme: window.matchMedia("(max-width: 768px)").matches ? 'list' : 'calendar',//this.props.theme || 'calendar',
            timeplan: {
                mandag: [
                    //{ from: '8:15', to: '9:30', label: 'History', location: 'A', categoryName: 'Test1', categoryId: 2 },
                ],
                tirsdag: [],
                onsdag: [],
                torsdag: [],
                fredag: [],
            },
            categories: {},
            activeCategory: props.data.default_category || 0,
        }

        this.times = ['7:00','7:30','8:00','8:30','9:00','9:30','10:00','10:30','11:00','11:30','12:00','12:30','13:00','13:30','14:00','14:30','15:00','15:30','16:00','16:30','17:00','17:30','18:00','18:30','19:00','19:30','20:00'];

        this.minuteHeight = 2;
    }

    componentDidMount() {
        api.slotFetcher.getAll({ args: { per_page: 1000 }}).then(resp => {
            if(resp.data && resp.data.length) {

                // gather categories
                const categories = resp.data.reduce((acc, slot) => ({...acc, [slot.acf.category.slug]: { name: slot.acf.category.name, id: slot.acf.category.term_id } }), {});
                this.setState({ categories });

                //console.log('RESP', resp.data);

                // gather and organise slots
                let slots = resp.data.reduce((acc, post) => {
                    const day = post.acf.day.slug
                    if(acc[day]) {
                        const slotData = {
                            from: post.acf.start_time, 
                            to: post.acf.end_time, 
                            label: post.title.rendered, 
                            location: post.acf.location, 
                            categoryName: post.acf.category.name,
                            categoryId: post.acf.category.term_id,
                        }
                        acc[day] = [...acc[day], slotData]
                    }
                    return acc
                }, {...this.state.timeplan})

                this.setState({ timeplan: slots });

                //console.log('SLOTS', slots);

            }
        })
    }

    _themeSwitcher() {
        const { theme } = this.state;

        return(
            <Container flex justify="center">
                <span className={['theme-switch', theme==='calendar'?'on':''].join(' ')} onClick={() => this.setState({ theme: 'calendar' })} >calendar</span>
                <span className={['theme-switch', theme==='pills'?'on':''].join(' ')} onClick={() => this.setState({ theme: 'pills' })} >pills</span>
                <span className={['theme-switch', theme==='list'?'on':''].join(' ')} onClick={() => this.setState({ theme: 'list' })} >list</span>
            </Container>
        )
    }

    _days() {
        const { timeplan } = this.state;

        return Object.keys(timeplan).map(day => <Day key={day}>{day}</Day> );
    }

    filteredSlots() {
        const { timeplan, activeCategory } = this.state;

        if(!activeCategory) return timeplan;

        return Object.keys(timeplan).reduce((acc, day) => {
            if(acc[day]) {
                acc[day] = acc[day].filter(slot => slot.categoryId === activeCategory)
            }
            return acc
        }, {...timeplan})
    }

    _daysWithList() {
        const { theme } = this.state;

        const slots = this.filteredSlots();

        return Object.keys(slots).map(day => {
            return(
                <DayListWrapper key={day}>
                    <Day>{day}</Day>
                    <ul>
                        {slots[day].map((cl, i) => <ClassItem key={day+'-'+i} data={cl} minuteHeight={this.minuteHeight} theme={theme} />)}
                    </ul>
                </DayListWrapper>
            );
        });
    }

    _timeSlots() {
        const { theme } = this.state;

        const slots = this.filteredSlots();

        return this._filteredTimes().map(time => {
            return (
                <TimeRow key={time} minuteHeight={this.minuteHeight} theme={theme}>
                    
                    {theme === 'calendar' && <span className="time-mark">{time}</span> }

                    {Object.keys(slots).map(day => {

                        const mTime = moment(time, 'h:mm');

                        const timeSlotClasses = slots[day].filter(cl => {
                            const mFrom = moment(cl.from, 'hh:mm');
                            const diff = mFrom.diff(mTime, 'minutes');
                            return diff >= 0 && diff < 30;
                        });

                        return(
                            <DayTimeSlot key={day+'-'+time} theme={theme} multipleClasses={timeSlotClasses.length > 1}>
                                {timeSlotClasses.map((cl, i) => <ClassItem key={day+'-'+time+'-'+i} data={cl} minuteHeight={this.minuteHeight} theme={theme} mTime={mTime} /> )}
                            </DayTimeSlot>
                        );
                    })}

                </TimeRow>
            );
        });
    }

    /**
     * Trim entries form 'tis.times' array that will not be requires for give nset of week classes
     */
    _filteredTimes() {

        const slots = this.filteredSlots();

        const weekMinMaxTimes = Object.keys(slots).reduce((acc, day) => {

            const dayMinMaxTimes = slots[day].reduce((acc, cl) => {

                const classStartMin = moment(cl.from, 'hh:mm').diff(moment().startOf('day'), 'minutes'); // minutes from start of day to class START time (ex. 8:00 => 480)
                const classEndMin = moment(cl.to, 'hh:mm').diff(moment().startOf('day'), 'minutes'); // minutes from start of day to class END time (ex. 10:00 => 600)

                if(classStartMin < acc.min) acc.min = classStartMin % 30 !== 0 ? classStartMin - (classStartMin % 30) : classStartMin;
                if(classEndMin > acc.max) acc.max = classEndMin % 30 !== 0 ? classEndMin + (classEndMin % 30) + (30 - (classEndMin % 30)) : classEndMin;

                return acc;

            }, {min: 1200, max: 0});

            if(dayMinMaxTimes.min < acc.min) acc.min = dayMinMaxTimes.min;
            if(dayMinMaxTimes.max > acc.max) acc.max = dayMinMaxTimes.max;

            return acc;

        }, {min: 1200, max: 0});

        //console.log(weekMinMaxTimes);

        return this.times.filter(time => {
            const timeMin = moment(time, 'h:mm').diff(moment().startOf('day'), 'minutes'); // minutes from start of day to given time (ex. 8:00 => 480)
            return timeMin >= weekMinMaxTimes.min && timeMin <= weekMinMaxTimes.max
        });
    }

    categorySelectOptions() {
        const { categories } = this.state;
        return sortByPath(Object.keys(categories).map(key => {
            return {
                name: categories[key].name,
                value: categories[key].id
            }
        }).filter(o => o.value), 'name')
    }
  
    render() {

        const { theme, activeCategory } = this.state;

        return (
            <Wrapper>
                
                <Container small>
                    <Select
                        name="category"
                        value={activeCategory}
                        onChange={e => this.setState({ activeCategory: Number(e.target.value) })}
                        options={this.categorySelectOptions()}
                        className="slot-category"
                    />
                </Container>

                <Container flex wrap small justify="space-between" className="slots-container">

                    {theme !== 'list' && this._days()}

                    {theme === 'list' && this._daysWithList()}

                    {theme !== 'list' && this._timeSlots()}

                </Container>
            </Wrapper>
        );
    }
}

export default Timeplan;

const ClassItem = props => {
    const { data, minuteHeight, theme, mTime } = props;

    const mFrom = moment(data.from, 'hh:mm');
    const mTo = moment(data.to, 'hh:mm');
    const diff = mFrom.diff(mTime, 'minutes');
    const height = mTo.diff(mFrom, 'minutes') * minuteHeight;

    return (
        <ClassItemWrapper height={height} span={diff * minuteHeight} theme={theme} noLocation={!data.location}>
            {data.location && <div className="location">{data.location}</div>}
            <div className="time">{data.from} - {data.to}</div>
            <div className="label">{data.label}</div>
        </ClassItemWrapper>
    );
}

const Wrapper = styled.div`
    position:relative;
    margin-bottom: 100px;

    .theme-switch {
        margin: 0 10px 30px;
        color: ${css.colors.main};
        cursor:pointer;
        &.on { text-decoration: underline; }
    }

    .slot-category {
        margin: 0 auto 40px;
        width:300px;
        > div, select {
            width: 300px;
        }
    }

    .slots-container {
        @media(max-width: 1024px) {
            padding-left:50px!important;
        }
        @media(max-width: 767px) {
            padding-left:20px!important;
        }
    }
`

const Day = styled.div`
    color:${css.colors.main};
    width:19%;
    text-align:center;
    margin-bottom: 30px;
    font-size:18px;
    font-weight: bold;
    text-transform: capitalize;

    ${props => props.theme === 'list' ? `
        width: 100%;
        text-align:left;
    ` : ``}
`

const DayListWrapper = styled.div`
    width:100%;
    > div { 
        text-align: left;
        margin: 0;
    }
    ul {
        padding:20px 0 15px;
    }
`

const TimeRow = styled.div`
    width:100%;
    color:${css.colors.main};
    position:relative;
    display: flex;
    justify-content: space-between;

    ${props => props.theme === 'calendar' ? `
        height: ${props.minuteHeight * 30}px;
        border-top:1px solid #C0C9D3;
    ` : ``}

    .time-mark {
        position:absolute;
        top: 0;
        left:0;
        transform: translateX(-120%) translateY(-50%);
        color: #798DA4;
    }
`

const DayTimeSlot = styled.div`
    width:19%;
    position:relative;

    ${props => props.theme === 'calendar' ? `
        > div {
            &:nth-child(2) { transform: translateY(calc(-100% * 1 + 10px)) scale(.97); z-index: 9; }
            &:nth-child(3) { transform: translateY(calc(-100% * 2 + 20px)) scale(.94); z-index: 8; }
            &:nth-child(4) { transform: translateY(calc(-100% * 3 + 30px)) scale(.91); z-index: 7; }
            &:nth-child(5) { transform: translateY(calc(-100% * 4 - 0px)) scale(.88); z-index: 6; }
            &:nth-child(6) { transform: translateY(calc(-100% * 5 - 0px)) scale(.85); z-index: 5;}
        }
    ` : ``}
`

const ClassItemWrapper = styled.div`
    font-size:13px;
    background: #EAF0F7;
    width:100%;
    border:1px solid #D1D9E5;
    margin-top:-1px;
    position: relative;
    z-index:10;
    color: ${css.colors.main};

    .location {
        float: left;
        margin-right:10px;
        font-size:20px;
        font-weight: bold;
        color:#fff;
        background: ${css.colors.main};
        padding: 5px;
        width:32px;
        height:32px;
        line-height:1;
        display:flex;
        justify-content:center;
        align-items: center;
        margin-top: -1px;
        margin-left: -1px;
    }

    .label {
        font-size: 16px;
        font-weight: 600;
    }

    ${props => props.theme === 'calendar' ? `
        height: ${props.height}px;
        top: ${props.span}px;
        padding: ${props.noLocation ? '10px' : '0'};
        .label {
            padding-left: ${props.noLocation ? '0' : '40px'};
            padding-right: ${props.noLocation ? '0' : '5px'};
        }
        .location {
            height:38px;
        }
        .time {
            padding-top:3px;
        }
    ` : ``}

    ${props => props.theme === 'pills' ? `
        margin-bottom:10px;
        padding:5px;
        overflow: hidden;
        border-radius: 30px;
        .location {
            border-radius: 30px;
        }
    ` : ``}

    ${props => props.theme === 'list' ? `
        margin-bottom:5px;
        border: 1px solid transparent;
        overflow: hidden;
        padding-left: ${props.noLocation ? '10px' : '0'};
        .time {
            float: right;
            padding-top: 5px;
            padding-right:10px;
        }
        .label {
            padding-top: 3px;
        }
    ` : ``}

    &:hover {
        //border:1px solid ${css.colors.main};
        //color: ${css.colors.main};
        //background: #f3f3f3;
        z-index: 11!important;
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/TimePlan/TimePlan.js